import moment from "moment";

const weekMapping = {
  id1: "week1",
  id2: "week2",
  id3: "week3",
  id4: "week4",
  id5: "week5",
  id6: "week6",
  id7: "week7",
  id8: "week8",
};


const week8Days = {
  id1id: "day1",
  id2id: "day2",
  id3id: "day3",
  id4id: "day4",
  id5id: "day5",
  id6id: "day6",
  id7id: "day7",

};

const getOzonState = {
  ozon: {
    data: [],
    weeks: [],
    columns: [],
    isClick: false,
    hasMore: true,
    currentPage: 1,
    totalItems: 0,
    totalPages: 1,
    pageSize: 50,
    currentCompanyId: null,

    sortByWeek: null,
    sortByWeekLastDay8: null,
    isAscending: false,
    sortPrice: false,
    sortStock: false,
    sorTarticle: false,
    averageOrdersBool: false,
    daysOfStockBool: false,
    turnoverVersion2Bool: false,
    sortedProducts: [],
    searchValue: "",
    isSearching: false,
    sortField: null,
    sortDir: "desc",
    isSorting: false,
  },
  loading: false,
  error: null,
};

// Функция для обновления вложенных значений
const getOzonisListReducer = (state = getOzonState, action) => {
  switch (action.type) {
    case "FETCH_OZON_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

      case "FETCH_OZON_SUCCESS": {
  const newData = action.payload.data || [];

  const filteredData = state.ozon.currentCompanyId
    ? newData.filter((item) => item.companyID === state.ozon.currentCompanyId)
    : newData;

  const weeks = Array.isArray(action.payload.weeks)
    ? action.payload.weeks
    : [];

  const updatedWeeks = weeks.map((week, index) => ({
    ...week,
    id: `id${index + 1}`,
    days: Object.entries(week.days || {}).map(([, day], dayIndex) => ({
      ...day,
      id: `id${dayIndex + 1}id`,
    })),
  }));

  const transformedColumns = [
    { id: "name", label: "Артикул продавца" },
    { id: "marketing_seller_price", label: "Цена" },
    { id: "stock", label: "Остатки FBO" },
    { id: "stockSeller", label: "Остатки FBS" },

    ...updatedWeeks.map((week, index) => ({
      id: week.id || index,
      label: (
        <>
          {moment(week.startDate).format("L")}
          <br />
          {moment(week.endDate).format("L")}
        </>
      ),
    })),
  ];

  const days = updatedWeeks[7]?.days || [];

  const transformedDays = days.map((day) => ({
    id: day.id,
    label: `${moment(day.date).format("L")}`,
  }));

  const previousColumns = state.ozon.columns || [];

  const newColumns = [
    ...transformedColumns,
    ...transformedDays,

    { id: "Ads", label: "Заказы в день, шт" },
    { id: "idcFbo", label: "Остатка хватит на дн FBO" },
    { id: "idcFBS", label: "Остатка хватит на дн FBS" },
    { id: "turnover", label: "Оборачиваемость" },
    { id: "feedbackRating", label: "Рейтинг" },
    { id: "avgPosition", label: "Средняя позиция" },
    { id: "visibility", label: "Видимость" },
    { id: "strategy", label: "Стратегия" },
    { id: "marketing", label: "Маркетинг" },
    { id: "quality", label: "Качество" },
    { id: "content", label: "Контент" },
  ];

  const mergedColumns = previousColumns.concat(
    newColumns.filter(
      (newCol) => !previousColumns.some((oldCol) => oldCol.id === newCol.id)
    )
  );

  return {
    ...state,
    loading: false,
    error: null,
    ozon: {
      ...state.ozon,

      // ВАЖНО:
      // для Pagination НЕ добавляем товары к старым,
      // а заменяем data на текущую страницу
      data: filteredData,

      weeks: updatedWeeks,
      columns: mergedColumns,

      totalItems: action.payload.totalItems ?? 0,
      totalPages: action.payload.totalPages ?? 1,
      currentPage: action.payload.currentPage ?? 1,
      pageSize: action.payload.pageSize ?? state.ozon.pageSize ?? 50,
      hasMore: Boolean(action.payload.hasMore),

      sortField: action.payload.sortField ?? state.ozon.sortField ?? "",
      sortDir: action.payload.sortDir ?? state.ozon.sortDir ?? "desc",

      isClick: state.ozon.isClick,
      searchValue: state.ozon.searchValue,

      sortByWeek: state.ozon.sortByWeek,
      sortPrice: state.ozon.sortPrice,
      sortStock: state.ozon.sortStock,
      sorTarticle: state.ozon.sorTarticle,
      sortByWeekLastDay8: state.ozon.sortByWeekLastDay8,
      averageOrdersBool: state.ozon.averageOrdersBool,
      daysOfStockBool: state.ozon.daysOfStockBool,
      turnoverVersion2Bool: state.ozon.turnoverVersion2Bool,
      isSorting: false,
    },
  };
}
    case "FETCH_OZON_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_OZON_COMMENT":
      const findComment = state.ozon.data.find(item => item.id === action.payload.id);

      if (findComment) {
        const updatedData = state.ozon.data.map(item =>
          item.id === action.payload.id
            ? {
              ...item,
              comments: {
                ...item.comments,
                [action.payload.commentType]: {
                  value: action.payload.comments,
                  date: action.payload.date,
                },
              },
            }
            : item
        );

        return {
          ...state,
          ozon: {
            ...state.ozon,
            data: updatedData,
          },
        };
      }

      return state; // Если элемент не найден

    case "REORDER_OZON_PRODUCTS":
      return {
        ...state,
        ozon: {
          ...state.ozon,
          data: action.payload,
        },
      };

    case "REORDER_OZON_COLUMNS":
      return {
        ...state,
        ozon: {
          ...state.ozon,
          columns: action.payload, // Сохраняем новый порядок колонок
        },
      };

    case "CLICK_ROWS":
      return {
        ...state,
        ozon: {
          ...state.ozon,
          isClick: action.payload, // Это должно переключать значение
        },
      };

    case "UPDATE_CURRENT_PAGE":
      return {
        ...state,
        ozon: {
          ...state.ozon,
          currentPage: action.payload, // Обновление currentPage
          searchValue: state.ozon.searchValue
        },
      };

    case "SET_CURRENT_COMPANY":
      return {
        ...state,
        ozon: {
          ...state.ozon,
          currentCompanyId: action.payload, // Устанавливаем текущую компанию
          currentPage: 1
        },
      };
    // это из клиента подкрутки обновляем сортировку
    case "SORT_WEEKS_BY_DATE_UPDATE":
      // Проверяем, существует ли неделя для сортировки
      if (state.ozon.sortByWeek) {
        const isAscending = state.ozon.isAscending;
        let sortDate = [...state.ozon.data].sort((a, b) => {
          // Используем state.ozon.sortByWeek для правильного доступа
          const aPercentage = a.weeks[state.ozon.sortByWeek]?.totalPercentage || 0;
          const bPercentage = b.weeks[state.ozon.sortByWeek]?.totalPercentage || 0;
          return isAscending ? bPercentage - aPercentage : aPercentage - bPercentage;
        });

        return {
          ...state,
          ozon: {
            ...state.ozon,
            data: sortDate,
            sortByWeek: state.ozon.sortByWeek, // Сохраняем текущую неделю для сортировки
            isAscending,
            sortStock: false,
            sorTarticle: false,
            sortByWeekLastDay8: null,
          },
        };
      }
      return state;
    // здесь назначить сортировку для недель
    case "SORT_WEEKS_BY_DATE": {
      const weekName = action.payload; // Получаем название недели из Action
      if (weekName) {
        const weekIndex = weekMapping[weekName]; // Находим индекс недели по идентификатору

        // Проверяем, существует ли неделя для сортировки
        if (weekIndex) {
          // Проверяем текущую сортировку для этой недели
          const isAscending = state.ozon.sortByWeek === weekIndex ? !state.ozon.isAscending : true;

          // Сортировка данных в зависимости от текущего направления
          state.ozon.data.sort((a, b) => {
            const aPercentage = a.weeks[weekIndex]?.totalPercentage || 0;
            const bPercentage = b.weeks[weekIndex]?.totalPercentage || 0;
            return isAscending ? bPercentage - aPercentage : aPercentage - bPercentage;
          });

          return {
            ...state,
            ozon: {
              ...state.ozon,
              sortByWeek: weekIndex, // Сохраняем текущую неделю для сортировки
              isAscending, // Добавляем флаг для направления сортировки
              sortPrice: false,
              sortStock: false,
              sorTarticle: false,
              sortByWeekLastDay8: null,
            },
          };
        }
      }

      return state; // Возвращаем текущее состояние, если неделя не найдена
    }

    // сортировка для цены
    case "SORT_PRICE_OZON":
      const isAscending = !state.ozon.isAscending
      return {
        ...state,
        ozon: {
          ...state.ozon,
          sortPrice: !state.ozon.sortPrice,
          sortPrice: true,
          sortStock: false,
          sorTarticle: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          data: state.ozon.data.sort((a, b) => {
            return state.ozon.isAscending ? (a.marketing_seller_price || 0) - (b.marketing_seller_price || 0) : (b.marketing_seller_price || 0) - (a.marketing_seller_price || 0);
          }),
        },
      };


    // Сортировка по остатку товара
    case "SORT_STOCK_OZON": {
      const isAscending = !state.ozon.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        ozon: {
          ...state.ozon,
          sortPrice: false,
          sortStock: true,
          sorTarticle: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          data: state.ozon.data.sort((a, b) => {
            return isAscending
              ? (b.stocks.stocks[0].present || 0) - (a.stocks.stocks[0].present || 0)
              : (a.stocks.stocks[0].present || 0) - (b.stocks.stocks[0].present || 0);
          }),
        },
      };
    }



    // сортировка по артикулу товара
    case "SORT_ACTICULE_OZON": {
      const isAscending = !state.ozon.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        ozon: {
          ...state.ozon,
          sortPrice: false,
          sortStock: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: true,
          data: state.ozon.data.sort((a, b) => {
            return isAscending
              ? (b.sku || 0) - (a.sku || 0)
              : (a.sku || 0) - (b.sku || 0);
          }),
        },
      };
    }



    // сортировка по дням для последней недели
    case "SORT_LASTWEEKDAY8_OZON": {
      const weekName = action.payload; // Получаем название недели из Action
      console.log(weekName, "action weekName");

      if (weekName) {
        const weekKey = week8Days[weekName]; // Получаем строковый ключ, например "day1"
        console.log(weekKey, "weekKey");

        if (weekKey) {
          // Проверяем текущую сортировку для этой недели
          const isAscending = state.ozon.sortByWeekLastDay8 === weekKey ? !state.ozon.isAscending : true;

          // Создаем копию массива перед сортировкой
          const sortedData = [...state.ozon.data].sort((a, b) => {
            // Проверяем, что `week8` существует и содержит нужный день, иначе 0
            const aPercentage = a.weeks.week8?.[weekKey]?.total ?? 0;
            const bPercentage = b.weeks.week8?.[weekKey]?.total ?? 0;
            return isAscending ? bPercentage - aPercentage : aPercentage - bPercentage;
          });

          return {
            ...state,
            ozon: {
              ...state.ozon,
              data: sortedData, // Используем отсортированные данные
              sortByWeekLastDay8: weekKey, // Сохраняем текущую неделю для сортировки
              sortByWeek: null,
              isAscending, // Добавляем флаг для направления сортировки
              sortPrice: false,
              sortStock: false,
              sorTarticle: false,
            },
          };
        }
      }

      return state; // Возвращаем текущее состояние, если неделя не найдена
    }



    // сортировка для средних заказа
    case "SORT_AVERAGEORDERS_OZON": {
      const isAscending = !state.ozon.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        ozon: {
          ...state.ozon,
          sortPrice: false,
          sortStock: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: false,
          averageOrdersBool: true,
          daysOfStockBool: false,
          turnoverVersion2Bool: false,
          data: state.ozon.data.sort((a, b) => {
            return isAscending
              ? (b.ads || 0) - (a.ads || 0)
              : (a.ads || 0) - (b.ads || 0);
          }),
        },
      };
    }


    //сортировка для  Остатка хватит на
    case "SORT_DAYS_STOCK_OZON": {
      const isAscending = !state.ozon.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        ozon: {
          ...state.ozon,
          sortPrice: false,
          sortStock: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: false,
          averageOrdersBool: false,
          daysOfStockBool: true,
          turnoverVersion2Bool: false,
          data: state.ozon.data.sort((a, b) => {
            return isAscending
              ? (b.idc || 0) - (a.idc || 0)
              : (a.idc || 0) - (b.idc || 0);
          }),
        },
      };
    }

    // сортировка для Оборачиваемость
    case "SORT_TURNOVER_OZON": {
      const isAscending = !state.ozon.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        ozon: {
          ...state.ozon,
          sortPrice: false,
          sortStock: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: false,
          averageOrdersBool: false,
          daysOfStockBool: false,
          turnoverVersion2Bool: true,
          data: state.ozon.data.sort((a, b) => {
            return isAscending
              ? (b.turnover || 0) - (a.turnover || 0)
              : (a.turnover || 0) - (b.turnover || 0);
          }),
        },
      };
    }


case "SET_SEARCH_VALUE":
  return {
    ...state,
    loading: false,
    ozon: {
      ...state.ozon,
      searchValue: action.payload,
      currentPage: 1,
      data: [],
      hasMore: true,
      totalItems: 0,
      totalPages: 1,
    },
  };

    case "SET_SERVER_SORT":
      return {
        ...state,
        ozon: {
          ...state.ozon,
          sortField: action.payload.sortField,
          sortDir: action.payload.sortDir,
          currentPage: 1,
          // флаги локальной сортировки выключим — всё делаем на сервере
          sortPrice: false,
          sortStock: false,
          sorTarticle: false,
          averageOrdersBool: false,
          daysOfStockBool: false,
          turnoverVersion2Bool: false,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          data: [],   // сброс перед новой загрузкой
          hasMore: true,
        },
      };

case "SET_SERVER_SORT_START":
  return {
    ...state,
    loading: false,
    error: null,
    ozon: {
      ...state.ozon,
      isSorting: true,
      sortField: action.payload.sortField,
      sortDir: action.payload.sortDir,
      currentPage: 1,
    },
  };

case "SET_SERVER_SORT_SUCCESS": {
  const newData = action.payload.data || [];

  return {
    ...state,
    loading: false,
    error: null,
    ozon: {
      ...state.ozon,

      data: newData,

      weeks: Array.isArray(action.payload.weeks)
        ? action.payload.weeks
        : state.ozon.weeks,

      totalItems: action.payload.totalItems ?? 0,
      totalPages: action.payload.totalPages ?? 1,
      currentPage: action.payload.currentPage ?? 1,
      pageSize: action.payload.pageSize ?? state.ozon.pageSize ?? 50,
      hasMore: Boolean(action.payload.hasMore),

      sortField: action.payload.sortField,
      sortDir: action.payload.sortDir,
      isSorting: false,

      sortByWeek: null,
      sortPrice: false,
      sortStock: false,
      sorTarticle: false,
      sortByWeekLastDay8: null,
      averageOrdersBool: false,
      daysOfStockBool: false,
      turnoverVersion2Bool: false,
    },
  };
}

case "SET_SERVER_SORT_ERROR":
  return {
    ...state,
    loading: false,
    error: action.payload,
    ozon: {
      ...state.ozon,
      isSorting: false,
    },
  };
case "SET_SERVER_SORT_SUCCESS":
  return {
    ...state,
    ozon: {
      ...state.ozon,
      // пришли новые отсортированные данные первой страницы
      data: action.payload.data || [],
      weeks: Array.isArray(action.payload.weeks) ? action.payload.weeks : state.ozon.weeks,
      hasMore: !!action.payload.hasMore,
      currentPage: 1,
      totalItems: action.payload.totalItems ?? state.ozon.totalItems,
      sortField: action.payload.sortField,
      sortDir: action.payload.sortDir,
      isSorting: false,
      // гасим все клиентские флаги сортировки
      sortPrice: false,
      sortStock: false,
      sorTarticle: false,
      averageOrdersBool: false,
      daysOfStockBool: false,
      turnoverVersion2Bool: false,
      sortByWeek: null,
      sortByWeekLastDay8: null,
    },
  };

case "SET_SERVER_SORT_ERROR":
  return {
    ...state,
    ozon: {
      ...state.ozon,
      isSorting: false,
    },
    error: action.payload,
  };


    default:
      return state;
  }
};

export default getOzonisListReducer;
